import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import Text from 'components/Core/Text';
import { ArrowRightIcon, ArrowRightHoverIcon } from 'components/Brand/Icons';
import { STIcon } from 'components/Brand/Icons/STIcon';
import speakerHeadshotFallback from 'images/speaker-fallback.png';
import { Container, GuestSpeakerItem, Title, SliderArrow } from './styles';

const WebinarGuestSpeaker = ({ speakers, onClickSpeaker, showAll = false, sidebar = false }) => {
  const [hovered, setHovered] = useState(-1);
  const [curSlideIndex, setCurSlideIndex] = useState(0);

  let slider;

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: showAll ? speakers?.length : 2,
    slidesToScroll: 1,
    autoplay: false,
    vertical: true,
    verticalSwiping: true,
    draggable: false,
    swipe: false,
  };

  const handlePrevClick = () => {
    if (curSlideIndex >= 1) {
      setCurSlideIndex(curSlideIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (curSlideIndex <= speakers?.length - 3) {
      setCurSlideIndex(curSlideIndex + 1);
    }
  };

  useEffect(() => {
    if (slider) {
      slider.slickGoTo(curSlideIndex);
    }
  }, [curSlideIndex]);

  const speakerContent = () =>
    speakers?.map((speaker, index) => {
      const { firstName, lastName, photo, jobTitle, company } = speaker;
      const speakerImage = photo?.image?.fluid?.src;

      return (
        <div className="webinar-guest-speaker--item" key={index}>
          <GuestSpeakerItem
            className={`webinar-guest-speaker--item-container ${
              hovered === index ? 'hovered' : ''
            } ${sidebar ? 'sidebar-mode' : ''}`}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(-1)}
            onClick={() => !sidebar && onClickSpeaker(index)}
          >
            <div className="webinar-guest-speaker--photo-container">
              <div
                className="webinar-guest-speaker--photo-image"
                style={{ backgroundImage: `url(${speakerImage || speakerHeadshotFallback})` }}
              />
            </div>
            <div className="webinar-guest-speaker--content-container">
              <Text
                type="h6"
                className="webinar-guest-speaker--name"
                size="large"
                marginMobile="0"
                color="Neutral 7"
              >
                {firstName} {lastName}
              </Text>
              <Text type="p" className="webinar-guest-speaker--job-text">
                {jobTitle}
              </Text>
              <Text type="p" className="webinar-guest-speaker--company-text">
                {company?.name}
              </Text>
              <Text type="p" className="webinar-guest-speaker--link-text">
                Full bio {hovered === index ? <ArrowRightHoverIcon /> : <ArrowRightIcon />}
              </Text>
            </div>
          </GuestSpeakerItem>
        </div>
      );
    });

  return (
    <Container className={`webinar-guest-speaker--container ${sidebar ? 'sidebar-mode' : ''}`}>
      <Title>Guest speakers</Title>

      <div className="webinar-guest-speaker--main-container">
        {sidebar ? (
          <>
            <Slider
              ref={c => {
                slider = c;
              }}
              {...settings}
            >
              {speakerContent()}
            </Slider>
            {!showAll && (
              <>
                <SliderArrow
                  className={`prev-arrow ${curSlideIndex === 0 ? 'disabled' : ''}`}
                  onClick={handlePrevClick}
                >
                  <STIcon type="icon-slider-arrow-right" />
                </SliderArrow>
                <SliderArrow
                  className={`next-arrow ${
                    curSlideIndex === speakers?.length - 2 ? 'disabled' : ''
                  }`}
                  onClick={handleNextClick}
                >
                  <STIcon type="icon-slider-arrow-right" />
                </SliderArrow>
              </>
            )}
          </>
        ) : (
          speakerContent()
        )}
      </div>
    </Container>
  );
};

export default WebinarGuestSpeaker;
